import ColorPickerPreview from "../../../../../components/ColorPickerPreview";
import CustomTooltip from "../../../../../components/CustomTooltip";
import React from "react";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const GeofenceCardHeader = ({backgroundColor, geofence}) => {
    return (
        <>
            <div className={`d-flex align-items-center gap-1 pb-2 ${backgroundColor}`}>
                <ColorPickerPreview fillColor={geofence?.fillColor} strokeColor={geofence.strokeColor}/>
                <div className={"flex-grow-1 minw-0"}>
                    <CustomTooltip
                        text={geofence?.name}
                        classes={"font-color-general-950 ibl-font-w-600 fs-16px text-ellipsis-2-rows ml-2"}
                        showIfTruncated={true}
                        placement={"top"}
                    />
                </div>
            </div>
        </>
    );
};
export default GeofenceCardHeader;
